import { css } from 'styled-components';
import { ie11Mixin, mediaMixin } from '@zillow/constellation';

/**
 * This mixin handles the "View More (n)" button. When there are fewer items than are currently displayed,
 * the button remains hidden. Using CSS variables, it also calculates how many items are hidden, and displays
 * that next to the button. The number of items part of the button is hidden on IE11.
 */
export default css`
  --num-items: ${(props) => props.numItems};
  ${mediaMixin(
    'sm_lte',
    css`
      --num-items-displayed: 1;
      ${(props) =>
        props.numItems > 1
          ? ''
          : css`
              display: none;
            `}
    `,
  )}
  ${mediaMixin(
    'md',
    css`
      --num-items-displayed: 2;
      ${(props) =>
        props.numItems > 2
          ? ''
          : css`
              display: none;
            `}
    `,
  )}
${mediaMixin(
    'lg',
    css`
      --num-items-displayed: 3;
      ${(props) =>
        props.numItems > 3
          ? ''
          : css`
              display: none;
            `}
    `,
  )}
${mediaMixin(
    'xl',
    css`
      --num-items-displayed: 4;
      ${(props) =>
        props.numItems > 4
          ? ''
          : css`
              display: none;
            `}
    `,
  )}
::after {
    /* Allows using a variable as a part of content, see https://stackoverflow.com/a/40179718 */
    counter-reset: variable calc(var(--num-items) - var(--num-items-displayed));
    content: ' (' counter(variable) ')';
  }
  /* Default to hiding the number of items for IE, since it doesnt support CSS vars */
  ${ie11Mixin(css`
    ::after {
      content: '';
    }
  `)}
  @media print {
    display: none;
  }
`;
